import { combineEpics, Epic, ofType } from 'redux-observable'
import { catchError, filter, map, of, switchMap, takeUntil } from 'rxjs'
import { getHub } from '../../../helpers/hub'
import { addToast } from '../../toasts/actions'
import { logError } from '../../ws/actions'
import { addData, FetchAction, fetchFail } from './actions'
import { UserDataTable } from './types'

const fetchUserDataEpic: Epic = (action$) =>
  action$.pipe(
    ofType('userData.fetchData'),
    switchMap((action: FetchAction) => {
      const {
        isExternal,
        gridName,
        queryUserId,
        queryCustId,
        startDate,
        endDate
      } = action.payload
      const getUserData$ = getHub().stream<UserDataTable>(
        'GetUserTableData',
        isExternal,
        queryUserId,
        queryCustId,
        startDate,
        endDate
      )
      return getUserData$.pipe(
        filter((data: UserDataTable) => data.initialized),
        map((data: UserDataTable) => addData(data.rows, gridName)),
        takeUntil(action$.pipe(ofType('userData.addData'))),
        catchError((err) =>
          of(
            fetchFail(err, gridName),
            logError(err),
            addToast({
              message: `${err.message}`,
              options: {
                toastId: `${gridName}-error`,
                type: 'error'
              }
            })
          )
        )
      )
    })
  )

export default combineEpics(fetchUserDataEpic)
